export const MAX_IMAGE_SIZE = 10 * 1024 * 1024; // 10MB
export const MAX_NAME_LENGTH = 50;
export const POLLING_INTERVAL = 3 * 1000; // 3 seconds
export const SCAN_PAY_DEADLINE = 30 * 60; // 30 minutes in seconds
